// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mw-160__GlzlY {\n  max-width: 160px;\n}\n.mw-200__gy7aU {\n  max-width: 200px;\n}\n.mw-250__bw337 {\n  max-width: 250px;\n}\n.mw-300__jjMsA {\n  max-width: 300px;\n}\n.mw-400__pFWaQ {\n  max-width: 400px;\n}\n.mw-500__KqiOS {\n  max-width: 500px;\n}\n.mw-none__vAON5 {\n  max-width: none;\n}\n.block__iGdTx {\n  display: block!important;\n}\n.test__tSzgv {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  position: relative;\n  width: 100%;\n}\n", "",{"version":3,"sources":["webpack://./src/utils/sizing.module.less"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;AAEA;EACI,gBAAA;AAAJ;AAGA;EACI,gBAAA;AADJ;AAIA;EACI,gBAAA;AAFJ;AAKA;EACI,gBAAA;AAHJ;AAMA;EACI,gBAAA;AAJJ;AAOA;EACI,eAAA;AALJ;AAQA;EACI,wBAAA;AANJ;AAUA;EACI,mBAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;AARJ","sourcesContent":[".mw-160 {\n    max-width: 160px;\n}\n\n.mw-200 {\n    max-width: 200px;\n}\n\n.mw-250 {\n    max-width: 250px;\n}\n\n.mw-300 {\n    max-width: 300px;\n}\n\n.mw-400 {\n    max-width: 400px;\n}\n\n.mw-500 {\n    max-width: 500px;\n}\n\n.mw-none {\n    max-width: none;\n}\n\n.block {\n    display: block!important;\n}\n\n\n.test {\n    -webkit-box-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    position: relative;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mw-160": "mw-160__GlzlY",
	"mw160": "mw-160__GlzlY",
	"mw-200": "mw-200__gy7aU",
	"mw200": "mw-200__gy7aU",
	"mw-250": "mw-250__bw337",
	"mw250": "mw-250__bw337",
	"mw-300": "mw-300__jjMsA",
	"mw300": "mw-300__jjMsA",
	"mw-400": "mw-400__pFWaQ",
	"mw400": "mw-400__pFWaQ",
	"mw-500": "mw-500__KqiOS",
	"mw500": "mw-500__KqiOS",
	"mw-none": "mw-none__vAON5",
	"mwNone": "mw-none__vAON5",
	"block": "block__iGdTx",
	"test": "test__tSzgv"
};
export default ___CSS_LOADER_EXPORT___;
